import FlatButton from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import React, { useCallback, useRef } from 'react';
import { Row } from 'components/Grid';
import TermsOfService from 'components/TermsOfService';
import PrintHandler from 'components/PrintHandler';
import Page from 'containers/Page';

const styles = {
  buttonWrapper: {
    justifyContent: 'flex-end',
    margin: '10px 0',
  },
};

const TermsOfServicePage = () => {
  const printRef = useRef(null);
  const printRow = (
    <Row style={styles.buttonWrapper}>
      <PrintHandler
        content={useCallback(() => printRef.current, [printRef])}
        trigger={useCallback(
          () => (
            <FlatButton startIcon={<PrintIcon />} primary>
              Print
            </FlatButton>
          ),
          [],
        )}
      />
    </Row>
  );
  return (
    <Page title='Terms of Service'>
      {printRow}
      <TermsOfService ref={printRef} />
      {printRow}
    </Page>
  );
};

export default TermsOfServicePage;
